export function renderWater(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  isDarkMode: boolean
) {
  const baseColor = isDarkMode ? '#0a4a5c' : '#1e88a8';
  ctx.fillStyle = baseColor;
  ctx.fillRect(0, 0, width, height);
}
